<template>
    <div class="column is-9">
        <section class="hero is-info welcome is-small">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        Estado de Cuenta.
                    </h1>
                    <h2 class="subtitle">
                        
                    </h2>
                </div>
            </div>
        </section>

        <section class="info-tiles">
            <div class="tile is-ancestor has-text-centered">
                <div class="tile is-parent">
                    <article class="tile is-child box">

                        <div>
                            <header class="card-header has-background-white-ter">
                                <p class="card-header-title">
                                    Movimientos
                                </p>

                                <a class="button is-small is-info m-t-r"
                                    @click="attemptGetDocument('account_status', 'account_status')">Descargar</a>
                            </header>

                            <div class="table-wrapper content mt-15">
                                <div class="content">
                                    <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th colspan="5" class="has-text-centered has-background-light has-text-link">
                                                    <div v-if="accountAmount > 0" class="notification is-danger is-light">
                                                        <strong>Esta cuenta posee pagos pendientes. <span class="has-text-warning"> Saldo: $ {{accountAmount}} </span></strong> 
                                                    </div>                                    
                                                </th>
                                            </tr>
                                            <tr>
                                                <th class="has-text-centered has-background-light has-text-link">Fecha</th>
                                                <th class="has-text-centered has-background-light has-text-link">Concepto</th>
                                                <th class="has-text-centered has-background-light has-text-link">Debe</th>
                                                <th class="has-text-centered has-background-light has-text-link">Haber</th>
                                                <th class="has-text-centered has-background-light has-text-link">Saldo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="( estado, index ) in accountStatus.data " v-bind:key="`estado-${index}`">
                                                <td>{{ estado.fecha | dateLatin }}</td>
                                                <td>{{ estado.concepto }}</td>
                                                <td class="has-text-right">{{ estado.debe }}</td>
                                                <td class="has-text-right">{{ estado.haber }}</td>
                                                <td class="has-text-right">{{ estado.saldo | FloatToFixed }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <footer class="card-footer ">
                                <div class="column">
                                    <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                                        <button class="pagination-previous" :disabled="accountStatus.current_page == 1" 
                                            @click.prevent="changePage(accountStatus.current_page-1)">Anterior</button>

                                        <button class="pagination-next" :disabled="accountStatus.current_page == accountStatus.last_page" 
                                            @click.prevent="changePage(accountStatus.current_page+1)">Próxima</button>
                                       
                                        <ul class="pagination-list">
                                            <li>
                                                <button class="pagination-link" v-show="accountStatus.current_page > 2" 
                                                    @click.prevent="changePage(1)">1</button>
                                            </li>

                                            <li>
                                                <span class="pagination-ellipsis" v-show="accountStatus.current_page > 3">&hellip;</span>
                                            </li>
                                                
                                            <li>
                                                <button class="pagination-link" v-show="accountStatus.current_page > 1" 
                                                    @click.prevent="changePage(accountStatus.current_page-1)">{{ accountStatus.current_page - 1 }}</button>                                                
                                                
                                            <li>
                                                <span class="pagination-link is-current" aria-label="Page 46" aria-current="page">{{accountStatus.current_page}}</span>
                                            </li>

                                            <li>
                                                <button class="pagination-link" 
                                                    v-show="accountStatus.current_page <= accountStatus.last_page-1" 
                                                    @click.prevent="changePage(accountStatus.current_page + 1)">{{ accountStatus.current_page + 1 }}</button>
                                            </li>
                                            
                                            <li>
                                                <span class="pagination-ellipsis" 
                                                    v-show="accountStatus.current_page < accountStatus.last_page-2">&hellip;</span>
                                            </li>

                                            <li>
                                                <button class="pagination-link" 
                                                    v-show="accountStatus.current_page <= accountStatus.last_page - 2" 
                                                    @click.prevent="changePage(accountStatus.last_page)">{{accountStatus.last_page}}</button>
                                            </li>                                          
                                        </ul>
                                    </nav>
                                </div>
                            </footer>
                        </div>

                    </article>
                </div>                
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'account-status',
    data() {
        return {
            estados: null
        }
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            errors: 'auth/errors',
            accountStatus: 'accountStatus/accountStatus',
            accountAmount: 'accountStatus/accountAmount',
        }),
    },
    methods: {
        ...mapActions({
            getDocument: 'documents/getDocument',
            getAccountStatus: 'accountStatus/getAccountStatus'
        }),        
        changePage(page){
            this.getAccountStatus(page);
        },
        attemptGetDocument(docName, docType){
            let data = { docName, docType };
            this.getDocument(data).catch((e) => {
                console.log(e);
            })
        }
    },
    components: {
        //
    }
}
</script>

<style>
.table-wrapper{
    overflow-x: auto;
}

.pagination > button, .pagination ul li > button {
    cursor: pointer;
}
.m-t-r{
    margin: 0.75rem 0.75rem 0;
}
</style>